"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoClearCroupierCommand = void 0;
const clear_croupier_action_1 = require("../../actions/clear-croupier-action");
class AutoClearCroupierCommand {
    constructor(playerManager, eventQueue) {
        this.playerManager = playerManager;
        this.eventQueue = eventQueue;
    }
    static isCommand(command) {
        return command instanceof AutoClearCroupierCommand;
    }
    executeCommand(_commandHash, _existingDeal, instant) {
        const clearCroupierAction = new clear_croupier_action_1.ClearCroupierAction(this.playerManager.board);
        clearCroupierAction.execute();
        clearCroupierAction.resolve();
        this.eventQueue.enqueue({
            type: "onCroupierCleared",
            instant,
            payload: { croupier: this.playerManager.croupier.clone() },
        });
        return Promise.resolve();
    }
}
exports.AutoClearCroupierCommand = AutoClearCroupierCommand;
